(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nix-header"]) return;
  try {
    
(function() {
  const header = document.getElementById('NixHeader');
  const toggle = document.getElementById('NixMobileMenuToggle');
  const menu = document.getElementById('NixMobileMenu');

  window.addEventListener('scroll', function() {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });

  if (toggle && menu) {
    toggle.addEventListener('click', function() {
      const isOpen = !menu.classList.contains('hidden');
      menu.classList.toggle('hidden');
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nix-home-collection-feature"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.nix-slider').forEach(function(slider) {
    const track = slider.querySelector('[id$="Track"]');
    if (!track) return;

    const slides = track.querySelectorAll('.nix-slide');
    let current = 0;

    function getVisible() {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth >= 640) return 2;
      return 1;
    }

    function update() {
      const visible = getVisible();
      const max = Math.max(0, slides.length - visible);
      current = Math.min(current, max);
      const pct = (100 / visible) * current;
      track.style.transform = 'translateX(-' + pct + '%)';
    }

    slider.querySelector('.nix-slider-prev').addEventListener('click', function() {
      current = Math.max(0, current - 1);
      update();
    });

    slider.querySelector('.nix-slider-next').addEventListener('click', function() {
      const visible = getVisible();
      current = Math.min(slides.length - visible, current + 1);
      update();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nix-home-collections"] && !Shopify.designMode) return;
  try {
    
(function() {
  const tabContainer = document.getElementById('NixCollectionTabs');
  if (!tabContainer) return;

  const tabs = tabContainer.querySelectorAll('button[role="tab"]');
  const panels = document.querySelectorAll('.nix-tab-panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p) { p.classList.add('hidden'); });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const targetId = tab.getAttribute('aria-controls');
      const target = document.getElementById(targetId);
      if (target) target.classList.remove('hidden');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nix-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-nix-gallery]').forEach(function(gallery) {
    const mainImg = gallery.querySelector('.nix-product-gallery-main__image');
    const thumbs = gallery.querySelectorAll('.nix-thumb');

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }

        thumbs.forEach(function(item) {
          item.classList.remove('active');
          item.setAttribute('aria-current', 'false');
        });

        thumb.classList.add('active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  document.querySelectorAll('.nix-product-form').forEach(function(form) {
    const qtyInput = form.querySelector('input[name="quantity"]');
    const variantIdInput = form.querySelector('[data-nix-variant-id]');
    const variantsScript = form.querySelector('[data-nix-variants]');
    const addButton = form.querySelector('[data-nix-add-to-cart]');
    const priceNode = form.querySelector('[data-nix-button-price]');
    let variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        variants = [];
      }
    }

    form.querySelectorAll('.nix-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const val = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.action === 'increase') qtyInput.value = val + 1;
        if (btn.dataset.action === 'decrease' && val > 1) qtyInput.value = val - 1;
      });
    });

    form.querySelectorAll('.nix-variant-btn input').forEach(function(input) {
      input.addEventListener('change', function() {
        const selected = [];

        form.querySelectorAll('.nix-variant-btn input:checked').forEach(function(checked) {
          selected[parseInt(checked.dataset.optionPosition, 10)] = checked.value;
        });

        const variant = variants.find(function(item) {
          return item.options.every(function(option, index) {
            return option === selected[index];
          });
        });

        if (!variant) return;

        if (variantIdInput) variantIdInput.value = variant.id;
        if (addButton) addButton.disabled = !variant.available;
        if (priceNode && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          priceNode.textContent = Shopify.formatMoney(variant.price);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nix-product-reviews"] && !Shopify.designMode) return;
  try {
    
  var NIX_STAR_SVG = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M9 0C9.7 6.1 11.9 8.3 18 9C11.9 9.7 9.7 11.9 9 18C8.3 11.9 6.1 9.7 0 9C6.1 8.3 8.3 6.1 9 0Z" fill="currentColor"/></svg>';

  function decorateNixStars(root) {
    var stars = (root || document).querySelectorAll('.nix-jdgm-skin .jdgm-star');
    for (var i = 0; i < stars.length; i++) {
      var el = stars[i];
      if (el.dataset.nixStarred === '1') continue;
      el.dataset.nixStarred = '1';
      el.textContent = '';
      el.innerHTML = NIX_STAR_SVG;
    }
  }

  function observeNixSkin() {
    var skin = document.querySelector('.nix-jdgm-skin');
    if (!skin) return;
    decorateNixStars(skin);
    var observer = new MutationObserver(function () {
      decorateNixStars(skin);
    });
    observer.observe(skin, { childList: true, subtree: true });
  }

  function initJudgeMeWidget() {
    if (!window.jdgm) return false;
    if (window.jdgm.reviewWidget && typeof window.jdgm.reviewWidget.initialise === 'function') {
      window.jdgm.reviewWidget.initialise();
      return true;
    }
    return false;
  }

  function tryInitJudgeMe(attemptsRemaining) {
    if (initJudgeMeWidget()) return;
    if (attemptsRemaining <= 0) return;
    window.setTimeout(function () {
      tryInitJudgeMe(attemptsRemaining - 1);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tryInitJudgeMe(40);
      observeNixSkin();
    });
  } else {
    tryInitJudgeMe(40);
    observeNixSkin();
  }

  } catch(e) { console.error(e); }
})();
})();
